import type { RootState } from "@/types";
import type { Bexrapport } from "@/types/bexSupport";
import type { BexrapportState } from "@/types/store";
import type { GetterTree } from "vuex";

export const getters: GetterTree<BexrapportState, RootState> = {
  getBexrapports(state): Bexrapport[] {
    return state.bexrapports.data;
  },
  getBexrapportsCount(state): number {
    return state.bexrapports.count;
  },
  getBexrapportsLoading(state): boolean {
    return state.bexrapports.loading;
  },
  getBexrapportsError(state): string | null {
    return state.bexrapports.error;
  },
  getBexrapport(state): Bexrapport {
    return state.bexrapport.data;
  },
};
